const $ = require('jquery');

$('.jquery-tabs').tabs();
